var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var controllers;
    (function (controllers) {
        var EditEmailAddressModalController = /** @class */ (function (_super) {
            __extends(EditEmailAddressModalController, _super);
            function EditEmailAddressModalController($scope, emailAddress, close) {
                var _this = _super.call(this, $scope, close) || this;
                _this.scope = $scope;
                _this.scope.emailAddress = emailAddress;
                return _this;
            }
            return EditEmailAddressModalController;
        }(controllers.BaseModalController));
        controllers.EditEmailAddressModalController = EditEmailAddressModalController;
    })(controllers = warsApp.controllers || (warsApp.controllers = {}));
})(warsApp || (warsApp = {}));
warsApp.registerController('EditEmailAddressModalController', ['$scope', 'emailAddress', 'close']);
